import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ChangeEvent } from 'react';
import DragDropFileUpload from 'components/DragDropFileUpload/DragDropFileUpload';
import AddFileButton from 'components/AddFileButton/AddFileButton';
import { useAppDispatch } from 'store/hooks';
import { addFilesInputHandler } from 'helpers';

const EmptyBox = () => {
    const dispatch = useAppDispatch();

    return (
        <Box display='flex' justifyContent='center'>
            <DragDropFileUpload addFileInputHandler={addFilesInputHandler} emptyView>
                <Box padding='60px' marginTop='140px'>
                    <Typography fontSize='24px' fontWeight={400} variant='h1' textAlign='center' marginBottom='29px'>
                        Dodaj pliki, które chcesz podzielić lub połączyć
                    </Typography>
                    <AddFileButton
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            addFilesInputHandler(e.target.files, dispatch, e)
                        }
                        styles={{ margin: '0 auto', height: '160px' }}
                    />
                </Box>
            </DragDropFileUpload>
        </Box>
    );
};

export default EmptyBox;
